import ar from './locale/ar';
import bg from './locale/bg';
import ca from './locale/ca';
import cs from './locale/cs';
import da from './locale/da';
import de from './locale/de';
import el from './locale/el';
import en from './locale/en';
import es from './locale/es';
import fa from './locale/fa';
import fi from './locale/fi';
import fr from './locale/fr';
import he from './locale/he';
import hi from './locale/hi';
import hu from './locale/hu';
import id from './locale/id';
import it from './locale/it';
import ja from './locale/ja';
import ko from './locale/ko';
import lv from './locale/lv';
import ml from './locale/ml';
import ms_MY from './locale/ms_MY';
import nl from './locale/nl';
import no from './locale/no';
import pl from './locale/pl';
import pt from './locale/pt';
import pt_BR from './locale/pt_BR';
import ro from './locale/ro';
import ru from './locale/ru';
import sk from './locale/sk';
import sr from './locale/sr';
import sv from './locale/sv';
import ta from './locale/ta';
import th from './locale/th';
import tr from './locale/tr';
import uk from './locale/uk';
import vi from './locale/vi';
import zh_CN from './locale/zh_CN';
import zh_TW from './locale/zh_TW';
import is from './locale/is';
import lt from './locale/lt';

const mergeWithFallback = (target = {}, fallback = {}) => {
  if (!fallback || typeof fallback !== 'object' || Array.isArray(fallback)) {
    return target;
  }

  const base =
    target && typeof target === 'object' && !Array.isArray(target)
      ? target
      : {};
  const result = { ...base };

  Object.entries(fallback).forEach(([key, fallbackValue]) => {
    const targetValue = base[key];
    if (targetValue === undefined || targetValue === null) {
      result[key] = fallbackValue;
      return;
    }
    if (
      typeof targetValue === 'object' &&
      targetValue !== null &&
      !Array.isArray(targetValue) &&
      typeof fallbackValue === 'object' &&
      fallbackValue !== null &&
      !Array.isArray(fallbackValue)
    ) {
      result[key] = mergeWithFallback(targetValue, fallbackValue);
      return;
    }
    result[key] = targetValue;
  });

  return result;
};

const preChatBuilderFallback = en?.INBOX_MGMT?.PRE_CHAT_FORM?.BUILDER || {};

const withPreChatBuilderFallback = locale => {
  const inboxMgmt = locale?.INBOX_MGMT || {};
  const preChatForm = inboxMgmt?.PRE_CHAT_FORM || {};

  return {
    ...locale,
    INBOX_MGMT: {
      ...inboxMgmt,
      PRE_CHAT_FORM: {
        ...preChatForm,
        BUILDER: mergeWithFallback(preChatForm.BUILDER, preChatBuilderFallback),
      },
    },
  };
};

export default {
  ar: withPreChatBuilderFallback(ar),
  bg: withPreChatBuilderFallback(bg),
  ca: withPreChatBuilderFallback(ca),
  cs: withPreChatBuilderFallback(cs),
  da: withPreChatBuilderFallback(da),
  de: withPreChatBuilderFallback(de),
  el: withPreChatBuilderFallback(el),
  en,
  es: withPreChatBuilderFallback(es),
  fa: withPreChatBuilderFallback(fa),
  fi: withPreChatBuilderFallback(fi),
  fr: withPreChatBuilderFallback(fr),
  he: withPreChatBuilderFallback(he),
  hi: withPreChatBuilderFallback(hi),
  hu: withPreChatBuilderFallback(hu),
  id: withPreChatBuilderFallback(id),
  it: withPreChatBuilderFallback(it),
  ja: withPreChatBuilderFallback(ja),
  ko: withPreChatBuilderFallback(ko),
  ml: withPreChatBuilderFallback(ml),
  ms_MY: withPreChatBuilderFallback(ms_MY),
  lv: withPreChatBuilderFallback(lv),
  nl: withPreChatBuilderFallback(nl),
  no: withPreChatBuilderFallback(no),
  pl: withPreChatBuilderFallback(pl),
  pt_BR: withPreChatBuilderFallback(pt_BR),
  pt: withPreChatBuilderFallback(pt),
  ro: withPreChatBuilderFallback(ro),
  ru: withPreChatBuilderFallback(ru),
  sk: withPreChatBuilderFallback(sk),
  sr: withPreChatBuilderFallback(sr),
  sv: withPreChatBuilderFallback(sv),
  ta: withPreChatBuilderFallback(ta),
  th: withPreChatBuilderFallback(th),
  tr: withPreChatBuilderFallback(tr),
  uk: withPreChatBuilderFallback(uk),
  vi: withPreChatBuilderFallback(vi),
  zh_CN: withPreChatBuilderFallback(zh_CN),
  zh_TW: withPreChatBuilderFallback(zh_TW),
  is: withPreChatBuilderFallback(is),
  lt: withPreChatBuilderFallback(lt),
};
